/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 157.0.0-SNAPSHOT
 */

export type BasketSummaryResponseSimType =
  (typeof BasketSummaryResponseSimType)[keyof typeof BasketSummaryResponseSimType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BasketSummaryResponseSimType = {
  TRIPLESIM: "TRIPLESIM",
  ESIM: "ESIM",
} as const;
